<template>
  <div class="syounin-group flex-container item-container">
    <loading v-if="!isInit" :message="'読み込み中...'"></loading>
    <p v-else-if="isError" class="aligncenter">読み込みに失敗しました</p>
    <p v-else-if="!isError && !syouninGroupList?.group_name" class="aligncenter">表示可能な承認グループがありません</p>
    <template v-else-if="!isError && syouninGroupList?.group_name">
      <div class="search-result">
        <scroll-table>
          <table>
            <thead>
              <tr>
                <template v-for="(item) in syouninGroupList.group_name">
                  <th colspan="2"><span>{{ item }}</span></th>
                </template>
              </tr>
              <tr>
                <template v-for="(row) in syouninGroupList.group_name">
                  <th>承認者</th>
                  <th>ユーザー名</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <template v-for="row in detailInfoList">
                <tr>
                  <template v-for="data in row">
                    <td>{{ data.syounin_str }}</td>
                    <td :class="{ 'weight': data.user_id == userId }">{{ data.staff_name }}</td>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
        </scroll-table>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref, ref, onMounted } from "vue";
import { useForm } from "@/composable/form/form";
import { dateFormat } from "@/filters/common";
import { SyozokuSyouninGroup, SyozokuSyouninGroupMember } from "@/types/SyouninGroup";
import { useSyainDetail } from "@/composable/syain/detail/init";

export default defineComponent({
  props: {
    userId: {
      type: Object as () => number | null,
      default: null,
    },
  },
  emits: {
    getInfo: () => true
  },
  setup(props) {
    // 初期処理
    const { getError } = useForm()
    const syouninGroupList: Ref<SyozokuSyouninGroup | null> = ref(null)
    const detailInfoList: Ref<SyozokuSyouninGroupMember[][] | null> = ref(null)
    const { userId, setUserId, getSyozokuSyouninGroup } = useSyainDetail()

    const isInit = ref(false)
    const isError = ref(false)
    onMounted(async () => {
      if (props.userId) {
        await setUserId(props.userId)
      }

      if (userId.value) {
        syouninGroupList.value = await getSyozokuSyouninGroup(userId.value)
        detailInfoList.value = syouninGroupList.value.detail_info
      } else {
        isError.value = true
      }
      isInit.value = true
    })

    return {
      getError,
      dateFormat,
      isError,
      isInit,
      syouninGroupList,
      detailInfoList,
      userId
    };
  },
  components: {
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/syain-detail.scss';
</style>
